import StringUtil from "../../../../../../app/util/StringUtil";
import InputValidationStateBo from "../../../../../../form/input/InputValidationStateBo";
import InputValidatorI from "../../../../../../form/input/InputValidatorI";

export default class VviBestaetigungValidatorOnClick implements InputValidatorI {

    private value: boolean;

    private vnKommEmailPrivatValid: boolean;

    private vnKommEmailPrivat: string

    constructor(newValue: boolean, newVnKommEmailPrivatValid: boolean, newVnKommEmailPrivat?: string) {
        this.value = newValue;
        this.vnKommEmailPrivatValid = newVnKommEmailPrivatValid;
        this.vnKommEmailPrivat = StringUtil.isBlank(newVnKommEmailPrivat) ? '.' : ` '${newVnKommEmailPrivat}'.`;
    }

    validate(): InputValidationStateBo {
        if (this.vnKommEmailPrivatValid === false) {
            return InputValidationStateBo.createInValid(
                `Die Dokumente können nicht ${this.value ? 'erneut' : ''} versendet werden. Bitte überprüfen Sie Ihre E-Mail-Adresse${this.vnKommEmailPrivat}`);
        }

        return InputValidationStateBo.createValid();
    }

}